import { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Form, Input, Divider, Row, Col } from "antd";

import Button from "antd-button-color";

import * as action from "store/actions";
import SocialAuth from "./SocialAuth";

const LoginContainer = ({ visible, onClose, switchHandler, extraAuthHandler }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      dispatch(action.getUser());
      onClose();
    }, 1000);
  };

  return (
    <>
      <Modal
        centered
        title=" "
        zIndex="1030"
        footer={null}
        onOk={onClose}
        visible={visible}
        onCancel={onClose}
        maskClosable={false}
        className="modal-auth"
        closeIcon={<i className="far fa-times" />}
      >
        <h4 className="fs-20-s">
          Masuk
          <Button
            type="link"
            className="fs-12 float-end text-secondary pt-2 px-0"
            onClick={switchHandler}
          >
            Daftar
          </Button>
        </h4>

        <Form layout="vertical" name="login" className="mt-4">
          <Form.Item label="Email" className="mb-3">
            <Input name="email" type="email" placeholder="Email" />
          </Form.Item>
          <Form.Item label="Password">
            <Input.Password name="password" type="password" placeholder="Password" />
          </Form.Item>
          <Form.Item className="mb-3">
            <Button type="dark" block loading={loading} onClick={onSubmitHandler}>
              Masuk
            </Button>
          </Form.Item>

          <Row justify="space-between">
            <Col md={12}>
              <Button type="link" className="fs-12 px-0" onClick={() => extraAuthHandler("reset")}>
                <span className="text-muted">Lupa password ?</span>
              </Button>
            </Col>
            <Col md={12} className="text-end">
              <Button
                type="link"
                className="fs-12 text-reset text-muted px-0"
                onClick={() => extraAuthHandler("resend")}
              >
                <span className="text-muted">Kirim ulang verifikasi</span>
              </Button>
            </Col>
          </Row>
        </Form>

        <Divider className="mb-4 mt-1" plain>
          <span className="text-muted">atau masuk dengan</span>
        </Divider>

        <SocialAuth text="Masuk dengan" />
      </Modal>
    </>
  );
};

export default LoginContainer;
